var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-collapsible-listbox',{attrs:{"icon":"lock","items":_vm.listboxItems,"selected":_vm.selectedProjectValue,"toggle-text":_vm.toggleText,"block":""},on:{"select":_vm.selectProject}})
}
var staticRenderFns = []

export { render, staticRenderFns }